export default __webpack_public_path__ + "static/media/robcan1.f3bd2a33.jpeg";